"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DemoUI = void 0;
var _core = require("@dragon/core");
require("./Base.scss");
var _demologo = _interopRequireDefault(require("./demologo.svg"));
var _logo = _interopRequireDefault(require("./logo.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DemoUI = exports.DemoUI = /*#__PURE__*/_createClass(function DemoUI() {
  var _this = this;
  _classCallCheck(this, DemoUI);
  _defineProperty(this, "data", void 0);
  _defineProperty(this, "menu", void 0);
  _defineProperty(this, "button", void 0);
  _defineProperty(this, "config", void 0);
  _defineProperty(this, "url", void 0);
  _defineProperty(this, "wrapper", void 0);
  _defineProperty(this, "clickCatch", void 0);
  _defineProperty(this, "rngUrl", void 0);
  _defineProperty(this, "toggle", function () {
    if (_core.CORE.getState().game.roundState !== _core.RoundState.Ended) return false;
    _this.button.style.display = "none";
    _this.menu.classList.add('show');
    _this.menu.style.display = "";
    _this.clickCatch.style.display = 'inherit';
  });
  _defineProperty(this, "OutSideClick", function () {
    _this.Close(null);
  });
  _defineProperty(this, "Close", function (e) {
    _this.menu.style.display = "none";
    _this.menu.classList.remove('show');
    _this.button.style.display = "";
    _this.clickCatch.style.display = 'none';
    if (e) {
      if (e.srcElement.getAttribute("data-id") == "-1") return;
      if (e.srcElement.getAttribute("data-id") == "-2") {
        document.body.removeChild(_this.wrapper);
        return;
      }
    }
  });
  _defineProperty(this, "ReplayRoundClick", function (e) {
    e.stopPropagation();
    if (_core.CORE.getState().game.roundState !== _core.RoundState.Ended) return false;
    _this.Close(null);
    var index = e.srcElement.getAttribute("data-id");
    var demoData = _this.data[index];

    // console.log('click')
    //  console.log(demoData)

    switch (demoData.type) {
      case 0:
        _core.CORE.dispatch({
          type: _core.REPLAY_ROUND_DEMO,
          payload: {
            roundId: demoData.roundId
          }
        });
        break;
      case 1:
        //  console.log(demoData)
        //  console.log(demoData.randomNumbers.split(','))

        fetch(_this.rngUrl + _this.config.playerId, {
          method: "POST",
          body: JSON.stringify({
            numbers: demoData.randomNumbers.replaceAll(' ', '').split(',')
          }),
          headers: {
            "Content-Type": "application/json"
          }
        }).then(function () {
          _core.CORE.dispatch({
            type: _core.SPIN_BUTTON
          });
        });
        break;
      default:
        // OLD, rng based, demo, still used by GDK.
        fetch(_this.rngUrl + _this.config.playerId, {
          method: "POST",
          body: JSON.stringify({
            numbers: demoData.numbers
          }),
          headers: {
            "Content-Type": "application/json"
          }
        }).then(function () {
          _core.CORE.dispatch({
            type: _core.SPIN_BUTTON
          });
        });
        break;
    }
  });
  var gc = document.getElementById("shock-game-container");
  // Create wrapper.
  this.wrapper = document.createElement("div");
  this.wrapper.className = "uiWrapper demoui";
  this.clickCatch = document.createElement("div");
  this.clickCatch.className = 'clickCatch';
  this.clickCatch.onclick = this.OutSideClick;
  this.button = document.createElement("div");
  this.button.className = "toggleButton";
  this.button.innerHTML = _demologo["default"];
  this.button.onclick = this.toggle;
  this.wrapper.appendChild(this.button);
  this.menu = document.createElement("div");
  this.menu.className = "outcomeList";
  //   this.menu.innerHTML = "outcomeList"
  this.menu.style.display = "none";
  this.wrapper.appendChild(this.menu);
  this.config = _core.CORE.getState().config;
  var regex = new RegExp("(http[s\\u017F]?:\\/\\/)?((?:(?![\\t-\\r \\/\\xA0\\u1680\\u2000-\\u200A\\u2028\\u2029\\u202F\\u205F\\u3000\\uD800-\\uDFFF\\uFEFF])[\\s\\S]|[\\uD800-\\uDBFF][\\uDC00-\\uDFFF])+\\/)((?:[\\0-\\uD7FF\\uE000-\\uFFFF]|[\\uD800-\\uDBFF][\\uDC00-\\uDFFF]|[\\uD800-\\uDBFF](?![\\uDC00-\\uDFFF])|(?:[^\\uD800-\\uDBFF]|^)[\\uDC00-\\uDFFF])*)", "gimy");
  var m;
  while ((m = regex.exec(this.config.serverUrl)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === regex.lastIndex) {
      regex.lastIndex++;
    }
    this.rngUrl = m[1] + m[2] + "api/player/rng/";
    this.url = m[1] + m[2] + "api/player/demo/";
  }
  var cancel = document.createElement("div");
  cancel.setAttribute("data-id", "-1");
  cancel.innerHTML = _core.CORE.translate('democancel');
  cancel.className = "testItem cancel";
  cancel.onclick = this.Close;
  this.menu.appendChild(cancel);
  //   console.log('this.config.gameId ' + this.config.gameId)
  fetch(this.url + this.config.gameId + "?iid=" + this.config.iId + '&context=' + this.config.context, {
    method: "GET",
    headers: {
      Accept: "application/json"
    }
  }).then(function (d) {
    d.json().then(function (data) {
      _this.data = data;
      //  console.log(data)
      for (var index = 0; index < data.length; index++) {
        var test = data[index];
        var element = document.createElement("div");
        //  element.title = test.comment;
        element.innerHTML = test.name;
        element.className = "testItem rng demoItem";
        switch (test.type) {
          case 0:
            element.className += " demoTypeRound";
            break;
          case 1:
            element.className += " demoTypeRng";
            break;
          default:
            break;
        }
        element.setAttribute("data-id", index.toString());
        element.onclick = _this.ReplayRoundClick;
        _this.menu.appendChild(element);
      }
    });
  })["catch"](function (e) {
    console.warn('Demo Rounds Failed to load');
    return;
  });
  var text = document.createElement("div");
  var logoelement = document.createElement("span");
  logoelement.innerHTML = _logo["default"];
  var textp = document.createElement("p");
  textp.innerHTML = _core.CORE.translate('demodesc');
  text.classList.add('demodesc');
  text.appendChild(textp);
  text.appendChild(logoelement);
  this.menu.appendChild(text);

  // Append all.
  this.wrapper.appendChild(this.clickCatch);
  gc.appendChild(this.wrapper);
  _core.CORE.subscribe('game.roundState', function (e) {
    if (e === _core.RoundState.Started) _this.Close(null);
  });
});
//# sourceMappingURL=DemoUI.js.map